(function (angular) {
    'use strict';

    angular.module('inboundRules')

        /**
         *
         */
        .factory('inboundRulesService',
            ['$http', '$q', 'portalConfig',
                function ($http, $q, portalConfig) {

                    var urlBase = portalConfig.urlBase;
                    //urlBase = 'http://localhost:8001';
                    var fac = {
                        getInboundRules: getInboundRules,
                        getInboundRule: getInboundRule,
                        createInboundRule: createInboundRule,
                        updateInboundRule: updateInboundRule,
                        deleteInboundRule: deleteInboundRule,
                    };

                    return fac;
                    /**
                     * GET "/apispaces/{id}/automation/inboundrules"
                     * @param {string} id - the api space Id
                     */
                    function getInboundRules(id) {

                        return $http.get(urlBase + "/apispaces/" + id + "/automation/inboundrules")
                            .then(getInboundRulesComplete)
                            .catch(getInboundRulesFailed);

                        function getInboundRulesComplete(response) {
                            return response.data;
                        }

                        function getInboundRulesFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }

                    }

                    /**
                     * GET "/apispaces/{id}/automation/inboundrules/{messageRuleId}"
                     * @param {string} id - the api space Id
                     * @param {string} messageRuleId - the message rules Id
                     */
                    function getInboundRule(id, messageRuleId) {

                        return $http.get(urlBase + "/apispaces/" + id + "/automation/inboundrules/" + messageRuleId)
                            .then(getInboundRuleComplete)
                            .catch(getInboundRuleFailed);

                        function getInboundRuleComplete(response) {
                            return response.data;
                        }

                        function getInboundRuleFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }

                    }
                    /**
                     * POST "/apispaces/{id}/automation/inboundrules/"
                     * @param {string} id - the api space Id
                     * @param {string} data - data of inboundRules to create
                     */
                    function createInboundRule(id, data) {
                        return $http.post(urlBase + "/apispaces/" + id + "/automation/inboundrules", data)
                            .then(createInboundRuleComplete)
                            .catch(createInboundRuleFailed);

                        function createInboundRuleComplete(response) {
                            return response.data;
                        }

                        function createInboundRuleFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }
                    /**
                     * PUT "/apispaces/{id}/automation/inboundrules/{messageRuleId}"
                     * @param {string} id - the api space Id
                     * @param {string} data - data of inboundRules to update
                     */
                    function updateInboundRule(id, data) {

                        return $http.put(urlBase + "/apispaces/" + id + "/automation/inboundrules/" + data.id, data)
                            .then(updateInboundRuleComplete)
                            .catch(updateInboundRuleFailed);

                        function updateInboundRuleComplete(response) {
                            return response.data;
                        }

                        function updateInboundRuleFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }


                    function deleteInboundRule(id, inboundRulesId) {

                        return $http.delete(urlBase + "/apispaces/" + id + "/automation/inboundrules/" + inboundRulesId)
                            .then(deleteInboundRuleComplete)
                            .catch(deleteInboundRuleFailed);

                        function deleteInboundRuleComplete(response) {
                            return response.data;
                        }

                        function deleteInboundRuleFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }


                }]);
})(window.angular);
